<div class="tw-hidden md:tw-block tw-py-3 tw-pl-2 tw-max-w-xs">
  <div *ngIf="borrower && visible$ | async" id="cadence-widget" [@rubberBand]="rubberBandState" (@rubberBand.done)="resetAnimation()" class="tw-rounded-md tw-h-14 tw-px-2 rounded overflow-hidden text-white d-flex">
    <div class="borrower-container tw-max-w-full py-1 px-2 flex-grow-1 text-truncate">
      <div class="tw-h-4 !tw-text-sm">Attempt #{{ attempt }} &mdash; {{ cadenceTitle }}</div>
      <a interactive [routerLink]="['/borrower/' + borrowerId]" class="borrower tw-cursor-pointer">{{ borrower }}</a>
    </div>
    <div class="px-2">
      <div class="d-flex h-100 align-items-center">
        <button mat-flat-button color="primary" data-cy="view-borrower-button" (click)="viewBorrower(borrowerId)" class="tw-mx-4">View</button>
      </div>
    </div>
  </div>
</div>
